import Beyond26System from './Beyond26Website';export default function App(){return <Beyond26System/>}